import { render, staticRenderFns } from "./swigi.vue?vue&type=template&id=18d47ae4&"
import script from "./swigi.vue?vue&type=script&lang=js&"
export * from "./swigi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports